export const BASE_URL = process.env.REACT_APP_BASE_URL as string;
export const OPERATIONS_URL = process.env.REACT_APP_OPERATIONS_URL as string;
export const AUTH_URL = process.env.REACT_APP_AUTH_URL as string;
export const AUDIENCE_URL = process.env.REACT_APP_AUDIENCE_URL as string;
export const REACT_APP_AMPLITUDE_API_KEY = process.env
	.REACT_APP_AMPLITUDE_API_KEY as string;
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID as string;
export const SENTRY_DSN = process.env.SENTRY_DSN;
